import React, { useEffect, useMemo, useRef, useState } from 'react';
import { Button, Input, Select, DatePicker } from 'antd';
import { StyledForm } from './StyledPost';
import { connect, useDispatch } from 'react-redux';
import Notification from 'dorothy/utils/alert';
import Cropper from 'react-cropper';
import 'cropperjs/dist/cropper.css';
import moment from 'moment';
import SunEditor from 'suneditor-react';
import 'suneditor/dist/css/suneditor.min.css';
import CodeMirror from 'codemirror';
import 'codemirror/mode/htmlmixed/htmlmixed';
import 'codemirror/lib/codemirror.css';
import { GET_LIST_AUTHOR_REQUEST } from '../constant';
import { GET_TAGS_REQUEST } from '../../Tags/ducks';
import { useSelector } from 'react-redux';
import jwtDecode from 'jwt-decode';

const { TextArea } = Input;
const { Option } = Select;

const PostForm = ({ isWaitingSave, postDetail = null, onSubmit, isEdit, authors }) => {
  let languageOptions = [
    { value: 'th', label: 'Thai (Thailand)' },
    { value: 'en', label: 'English (Thailand)' },
    { value: 'my', label: 'English (Malaysia)' },
  ];

  const token = sessionStorage.getItem('token');
  if (token) {
    const decoded = jwtDecode(token);
    switch (decoded.dbName) {
      case 'MY':
        languageOptions = languageOptions.filter(option => option.value === 'my');
        break;
      case 'TH':
        languageOptions = languageOptions.filter(option => option.value !== 'my');
        break;
    }
  }

  const languageOptionsElements = useMemo(
    () =>
      languageOptions.map(option => (
        <Option key={option.value} value={option.value}>
          {option.label}
        </Option>
      )),
    [languageOptions],
  );

  const [formData, setFormData] = useState({
    content: '',
    description: '',
    title: '',
    urlTitle: '',
    language: languageOptions[0].value,
    author: 0,
    datePublic: null,
    tags: [],
  });
  const [loadContent, setLoadContent] = useState(true);
  const formatDate = ['DD/MM/YYYY', 'YYYY/MM/DD'];

  const option = {
    toolbarContainer: '#toolbar_container',
    codeMirror: CodeMirror,
    buttonList: [
      ['undo', 'redo'],
      ['font', 'fontSize', 'formatBlock'],
      ['paragraphStyle', 'blockquote'],
      ['bold', 'underline', 'italic', 'strike', 'subscript', 'superscript'],
      ['fontColor', 'hiliteColor', 'textStyle'],
      ['removeFormat'],
      '/', // Line break
      ['outdent', 'indent'],
      ['align', 'horizontalRule', 'list', 'lineHeight'],
      ['table', 'link', 'image'],
      ['fullScreen', 'showBlocks', 'codeView'],
      ['preview', 'print'],
    ],
    font: [
      'Montserrat',
      'Roboto',
      'Arial',
      'Comic Sans MS',
      'Courier New',
      'Impact',
      'Georgia',
      'tahoma',
      'Trebuchet MS',
      'Verdana',
    ],
  };
  const [upImg, setUpImg] = useState(null);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [cropData, setCropData] = useState('');
  const [cropper, setCropper] = useState();
  const contentRef = useRef('');
  const fileInputRef = useRef(null);
  const onChange = e => {
    e.preventDefault();
    let files;
    if (e.dataTransfer) {
      files = e.dataTransfer.files;
    } else if (e.target) {
      files = e.target.files;
    }
    const reader = new FileReader();
    reader.onload = () => {
      setUpImg(reader.result);
      setIsModalVisible(true);
      if (fileInputRef.current) {
        fileInputRef.current.value = null; // Clear the input value
      }
    };
    reader.readAsDataURL(files[0]);
  };

  const getCropData = e => {
    e.preventDefault();
    if (typeof cropper !== 'undefined') {
      const image = cropper.getCroppedCanvas().toDataURL();
      handleComplete(image);
      setCropData(image);
      formData.imageUrl = image;
      setIsModalVisible(false);
    }
  };

  const dispatch = useDispatch();
  useEffect(() => {
    dispatch({
      type: GET_LIST_AUTHOR_REQUEST,
      type: GET_TAGS_REQUEST,
    });
  }, []);

  const { data: tags } = useSelector(state => state.tags);

  useEffect(() => {
    if (postDetail && isEdit) {
      let tagsValue = [];
      if (typeof postDetail.tags === 'string') {
        tagsValue = postDetail.tags.split(',').map(id => parseInt(id, 10));
      } else if (Array.isArray(postDetail.tags)) {
        tagsValue = postDetail.tags.map(tag => tag.tagsid || tag.id || tag);
      }
      setFormData({ ...postDetail, tags: tagsValue });
    }
  }, [postDetail, isEdit, tags]);
  const handleChange = (type, value) => {
    setFormData({ ...formData, [type]: value });
  };

  const urltoFile = (url, filename, mimeType) => {
    return fetch(url)
      .then(function (res) {
        return res.arrayBuffer();
      })
      .then(function (buf) {
        return new File([buf], filename, { type: mimeType });
      });
  };

  const handleComplete = async image => {
    const randomNameFile = Math.random().toString(36).substring(7);
    const result = await urltoFile(image, `${randomNameFile}.png`, 'image/png');
    handleChange('file', result);
  };

  const onValidate = async ({ postId, urlTitle, languageTo }) => {
    const request = {
      postId,
      urlTitle,
      languageTo,
    };
    const res = await fetch(`/api/posts/validate`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(request),
    });
    const { data } = await res.json();
    return data;
  };

  const handleSubmit = async () => {
    const { title, urlTitle, description, language, file, content, tags } = formData;
    if (!title) {
      return Notification.error('Title is required');
    }
    if (formData.get && typeof formData.get === 'function' && formData.get('tags')) {
      const tagsArr = formData.get('tags');
      if (Array.isArray(tagsArr)) {
        formData.set('Tags', tagsArr.join(','));
      }
    }
    if (!urlTitle) {
      return Notification.error('URL Title is required');
    } else {
      const isValid = await onValidate({
        postId: formData.postId,
        urlTitle: formData.urlTitle,
        languageTo: formData.language,
      });
      if (!isValid) {
        return Notification.error('URL Title already exists');
      }
    }

    if (!description) {
      return Notification.error('Description is required');
    }

    if (!language) {
      return Notification.error('Language is required');
    }

    if (!isEdit && !file) {
      return Notification.error('Image is required');
    }

    if (!content && !contentRef.current) {
      return Notification.error('Content is required');
    }

    const data = new FormData();
    if (contentRef.current) {
      formData.content = contentRef.current;
    }

    if (Array.isArray(tags)) {
      data.append('Tags', tags.join(','));
    }

    for (const prop in formData) {
      data.append(prop, formData[prop]);
    }

    onSubmit({
      form: data,
      postId: formData.postId,
    });
  };

  const disabledDate = current => {
    return current && current < moment();
  };

  const handleChangeEditor = data => {
    contentRef.current = data;
  };

  const handleLoad = event => {
    if (event) {
      setLoadContent(false);
    }
  };

  return (
    <StyledForm>
      <div className="post-form-content">
        <div className="post-form-left">
          <div>
            <SunEditor
              height="calc(100vh - 330px)"
              placeholder="Start writing..."
              setOptions={option}
              // disable={loadContent}
              enableToolbar={true}
              showToolbar={true}
              autoFocus={false}
              setContents={formData.content ? formData.content : ''}
              onChange={handleChangeEditor}
              onLoad={handleLoad}
            />
          </div>
        </div>
        <div className="post-form-right">
          <div>
            <label>Blog Title</label>
            <Input
              placeholder="Blog Title"
              value={formData.title}
              onChange={e => handleChange('title', e.target.value)}
            />
          </div>
          <div>
            <label>URL</label>
            <Input
              placeholder="URL"
              value={formData.urlTitle}
              onChange={e => handleChange('urlTitle', e.target.value)}
            />
          </div>

          <div>
            <label>Description</label>
            <TextArea
              placeholder="Description"
              showCount
              maxLength={500}
              value={formData.description}
              onChange={e => handleChange('description', e.target.value)}
            />
          </div>
          <div>
            <label style={{ marginRight: '30px' }}>Publish Date</label>
            <DatePicker
              style={{ width: '100%' }}
              placeholder="Publish Date"
              value={formData.datePublic ? moment(formData.datePublic, formatDate[0]) : undefined}
              format={formatDate}
              disabledDate={disabledDate}
              onChange={(date, dateString) => handleChange('datePublic', dateString)}
            />
          </div>
          <div>
            <label>Language (Region)</label>
            <div>
              <Select
                value={formData.language}
                style={{ width: '100%' }}
                onChange={value => {
                  handleChange('language', value);
                }}
              >
                {languageOptionsElements}
              </Select>
            </div>
          </div>
          <div>
            <label>Author</label>
            <div>
              <Select
                value={formData.author}
                style={{ width: '100%' }}
                onChange={value => {
                  handleChange('author', value);
                }}
              >
                <Option value={0}>N/A</Option>
                {authors?.data &&
                  authors.data.map(author => (
                    <Option key={author.authorId} value={author.authorId}>
                      {author.nickName}
                    </Option>
                  ))}
              </Select>
            </div>
          </div>
          <div>
            <label>Tags</label>
            <div>
              <Select
                mode="multiple"
                value={formData.tags || []}
                style={{ width: '100%' }}
                placeholder="Select tags"
                onChange={value => handleChange('tags', value)}
              >
                {tags?.map(tag => (
                  <Option key={tag.tagsid} value={tag.tagsid}>
                    {tag.tagsname_eng} {tag.tagsname_th && `(${tag.tagsname_th})`}
                  </Option>
                ))}
              </Select>
            </div>
          </div>
          <div>
            <label>Feature Image </label>
            <Button
              style={{ width: '100%', marginBottom: '10px' }}
              onClick={() => fileInputRef.current && fileInputRef.current.click()}
            >
              Select Image
            </Button>
            <input type="file" onChange={onChange} style={{ display: 'none' }} ref={fileInputRef} />
            {isModalVisible && (
              <div className="crop-image-popup">
                <div className="crop-image-content">
                  <div
                    style={{
                      display: 'flex',
                      justifyContent: 'space-between',
                      marginBottom: '10px',
                    }}
                  >
                    <div
                      style={{
                        fontSize: '16px',
                        fontWeight: 'bold',
                        textAlign: 'center',
                        marginBottom: '10px',
                      }}
                    >
                      Crop Image
                    </div>
                    <Button onClick={getCropData}>Crop Image</Button>
                  </div>
                  <div
                    style={{
                      height: 'calc(100% - 50px)',
                      overflow: 'auto',
                    }}
                  >
                    {upImg && (
                      <>
                        <Cropper
                          zoomTo={1}
                          aspectRatio={1}
                          viewMode={1}
                          preview=".img-preview"
                          src={upImg}
                          guides={true}
                          minCropBoxHeight={10}
                          minCropBoxWidth={10}
                          background={true}
                          data={{
                            width: 500,
                            height: 500,
                          }}
                          responsive={false}
                          checkOrientation={false}
                          cropBoxResizable={true}
                          dragMode="none"
                          onInitialized={instance => {
                            setCropper(instance);
                          }}
                        />
                      </>
                    )}
                  </div>
                </div>
              </div>
            )}
            {formData?.imageUrl && (
              <div style={{ textAlign: 'center' }}>
                <img
                  src={formData?.imageUrl}
                  alt="img"
                  style={{
                    marginTop: '10px',
                    borderRadius: '30px',
                    width: '250px',
                    height: '250px',
                  }}
                />
              </div>
            )}
          </div>
          <Button
            className="post-form-save-btn"
            style={{ marginTop: '10px', marginBottom: '10px', width: '100%' }}
            type="submit"
            size={'large'}
            onClick={handleSubmit}
            loading={isWaitingSave}
          >
            Save
          </Button>
        </div>
      </div>
    </StyledForm>
  );
};

export default connect(state => ({
  isWaitingSave: state.post.isWaitingSave,
  postDetail: state.post.postDetail,
  authors: state.post.authors,
}))(PostForm);
